<template>
    <div class="flex items-center cursor-pointer" @click="onClick">
        <slot>
            <span class="text-black opacity-60 transition-colors hover:text-red hover:opacity-100">{{ label }}</span>
        </slot>
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component, Prop, Inject, Watch } from 'vue-property-decorator';

@Component
export default class DropdownItem extends Vue {
    @Prop() label: string;
    @Prop({ default: '' }) value: string;
    @Prop({ default: false, type: Boolean }) active: boolean;
    @Prop({ default: false, type: Boolean }) disabled: boolean;
    @Prop({ default: false, type: Boolean }) cancelable: boolean;
    @Inject({
        default: () => null
    }) readonly register!: Function;

    mounted(): void {
        // register self on parent component
        if (this.register) {
            this.register(this);
        }
    }

    onClick(): void {
        if (this.disabled) {
            return;
        }
        this.$emit('click', { label: this.label, value: this.value });
    }

    @Watch('active')
    onActiveChange() {
        if (!this.active) {
            this.$emit('deactivate');
        }
    }
}
</script>
